import { useQuery } from "react-query";
import { keyBy } from "lodash";
import { getAttributeFeedback } from "components/attributes/attribute-feedback/lib/data";
import { attributeFeedbackQueryKey } from "components/attributes/attribute-feedback/lib/constants";

export const useAttributeFeedback = (taskKey, enabled = true) => {
    return useQuery({
        queryKey: [attributeFeedbackQueryKey, taskKey],
        queryFn: () => getAttributeFeedback(taskKey),
        enabled: !!taskKey && enabled,
        retry: false,
        select: (feedback) => keyBy(feedback, "attributeUuid"),
    });
};
